import { useSelector } from 'react-redux'
import { AppState } from '../index'
import { LotteryState } from './index'

export function useLotteryData(): LotteryState {
  const lottery = useSelector<AppState, AppState['lottery']>((state) => state.lottery)
  return lottery
}
